
import { useState } from 'react';

export default function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/form/d6c0ue2tehdqnvnpi6ng', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contacto" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/a9d5b23f0c513e7143accea223d57c4e.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-petrol-700/85"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-6xl font-bold mb-6 leading-tight">
              Comienza Tu<br />Transformación
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Agenda tu evaluación gratuita y descubre cómo podemos transformar tu sonrisa con los tratamientos más avanzados.
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div>
                  <div className="text-sm text-white/80">Llámanos</div>
                  <div className="text-lg font-semibold">+34 900 123 456</div>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <div>
                  <div className="text-sm text-white/80">Email</div>
                  <div className="text-lg font-semibold">info@ortodonciaespecializada.com</div>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div>
                  <div className="text-sm text-white/80">Horario</div>
                  <div className="text-lg font-semibold">Lun - Vie: 9:00 - 20:00</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-2xl">
            <h3 className="text-3xl font-bold text-petrol-700 mb-6">Solicita tu Consulta</h3>
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-4">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-petrol-700 mb-2">
                    Nombre Completo
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-olive-500 focus:ring-2 focus:ring-olive-500/20 outline-none transition-all text-sm"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-petrol-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-olive-500 focus:ring-2 focus:ring-olive-500/20 outline-none transition-all text-sm"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-petrol-700 mb-2">
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-olive-500 focus:ring-2 focus:ring-olive-500/20 outline-none transition-all text-sm"
                    placeholder="+34 600 000 000"
                  />
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-semibold text-petrol-700 mb-2">
                    Mensaje
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-olive-500 focus:ring-2 focus:ring-olive-500/20 outline-none transition-all resize-none text-sm"
                    placeholder="Cuéntanos sobre tu caso..."
                  ></textarea>
                  <div className="text-xs text-petrol-400 mt-1 text-right">
                    {formData.mensaje.length}/500 caracteres
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-olive-500 text-white py-4 rounded-full font-semibold hover:bg-olive-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Enviando...' : 'Agendar Evaluación Gratuita'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-olive-50 border border-olive-200 text-olive-700 px-4 py-3 rounded-lg text-sm">
                    ¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                    Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo.
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
